import request from "./request/request";

export interface DeployQueryResponse<TValue = unknown> {
  value?: TValue;
}

export const DeployService = Object.freeze({
  query: <TValue = unknown>(key: string) => {
    return request.post<DeployQueryResponse<TValue>>(
      "/api/rendering/user/deploy/query",
      {
        key,
      }
    );
  },
});
